import { c } from 'react-compiler-runtime';
import { AlertFillIcon, CheckCircleFillIcon, AlertIcon, CheckCircleIcon } from '@primer/octicons-react';
import { clsx } from 'clsx';
import classes from './InlineMessage.module.css.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const icons = {
  warning: /*#__PURE__*/jsx(AlertIcon, {
    className: classes.InlineMessageIcon
  }),
  critical: /*#__PURE__*/jsx(AlertIcon, {
    className: classes.InlineMessageIcon
  }),
  success: /*#__PURE__*/jsx(CheckCircleIcon, {
    className: classes.InlineMessageIcon
  }),
  unavailable: /*#__PURE__*/jsx(AlertIcon, {
    className: classes.InlineMessageIcon
  })
};
const smallIcons = {
  warning: /*#__PURE__*/jsx(AlertFillIcon, {
    className: classes.InlineMessageIcon,
    size: 12
  }),
  critical: /*#__PURE__*/jsx(AlertFillIcon, {
    className: classes.InlineMessageIcon,
    size: 12
  }),
  success: /*#__PURE__*/jsx(CheckCircleFillIcon, {
    className: classes.InlineMessageIcon,
    size: 12
  }),
  unavailable: /*#__PURE__*/jsx(AlertFillIcon, {
    className: classes.InlineMessageIcon,
    size: 12
  })
};
function InlineMessage(t0) {
  const $ = c(15);
  let children;
  let className;
  let rest;
  let t1;
  let variant;
  if ($[0] !== t0) {
    ({
      children,
      className,
      size: t1,
      variant,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = rest;
    $[4] = t1;
    $[5] = variant;
  } else {
    children = $[1];
    className = $[2];
    rest = $[3];
    t1 = $[4];
    variant = $[5];
  }
  const size = t1 === undefined ? "medium" : t1;
  const icon = size === "small" ? smallIcons[variant] : icons[variant];
  let t2;
  if ($[6] !== className) {
    t2 = clsx(className, classes.InlineMessage);
    $[6] = className;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== children || $[9] !== icon || $[10] !== rest || $[11] !== size || $[12] !== t2 || $[13] !== variant) {
    t3 = /*#__PURE__*/jsxs("div", {
      ...rest,
      className: t2,
      "data-size": size,
      "data-variant": variant,
      children: [icon, children]
    });
    $[8] = children;
    $[9] = icon;
    $[10] = rest;
    $[11] = size;
    $[12] = t2;
    $[13] = variant;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
}

export { InlineMessage };
